import { ValueFormatterParams } from 'ag-grid-community';
import { FC } from 'react';
import {
    Buttons, Page, TableWrapper
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';
import Button from '../../../../components/Button/Button';
import { ButtonContainer } from './Confirmation.style';
import { Variant } from '../../../../components/Button/Button.types';
import { ChangeSpecsStep } from "../ChangeSpecs.types";
import { createTheme, styled, ThemeProvider, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


const Confirmation: FC<ConfirmationProps> = ({
                                                 rowData,
                                                 setStep
                                             }) => {
    const muiTheme = createTheme()
                                                
    const columnDefs = [
        { minWidth: 220, flex: 1, field: 'currentSpecNo', headerName: 'Current Spec' },
        { minWidth: 220, flex: 1, field: 'menuNo', headerName: 'MenuID/No' },
        { minWidth: 220, flex: 1, field: 'newSpecNo', headerName: 'New Spec' },
        { minWidth: 320, flex: 2, field: 'description', headerName: 'Description', cellRenderer: (params: any) => {
            if(params.value) {
                return <div style={{ display: 'flex', alignItems: 'center' }}>
                    {errorDescriptionColumn()}
                    <span>{params.value}</span>
                </div>;
            }
            return params.value;
        } },
        {
            minWidth: 220,
            flex: 1,
            field: 'createdDate',
            headerName: 'Date/Time',
            resizable: false,
            valueFormatter: (params: ValueFormatterParams) =>
                `${new Date(params.value).toLocaleDateString()} ${new Date(params.value).toLocaleTimeString()}`
        }
    ];

      const AlertTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
          ))(({ theme }) => ({
            [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(255, 0, 0, 0.8)',
            boxShadow: theme.shadows[5],
            fontSize: 14,
            height: '30px',
            paddingTop: '20px',
            },
            [`& .${tooltipClasses.arrow}`]: {
              color: theme.palette.common.white,
            },
      }));
    

    const errorDescriptionColumn = () => {
        return <ThemeProvider theme={muiTheme}>
        <AlertTooltip title={'Record is not updated'} arrow>
          <ErrorOutlineIcon fontSize='small' aria-label='Incomplete' style={{
            marginRight: '.5rem',
            color: 'red',
            marginLeft: '.5rem',
            alignContent: 'center',
          }} />
        </AlertTooltip>
          </ThemeProvider>
    }

    const resetSpecSelection = () => {
        setStep(ChangeSpecsStep.SelectSpec);
    }

    return (
        <>
            <Page data-testid="ConfirmationPage">
                <TableWrapper>
                    <Table
                        floatingFiltersHeight={0}
                        returnedRecords={rowData?.length}
                        columnDefs={columnDefs}
                        rowData={rowData}
                    />
                </TableWrapper>
                <Buttons>
                    <Export
                        testId="ExportChangesButton"
                        columnHeaders={columnDefs.map((col) => {
                            return { field: col.field, headerName: col.headerName };
                        })}
                        rowData={rowData}
                    />
                </Buttons>
            </Page>
            <ButtonContainer>
                <Button label="Select specs" variant={Variant.Secondary} onClick={resetSpecSelection}/>
            </ButtonContainer>
        </>
    );
};

export default Confirmation;